
import ExampleJobItem from "./ExampleJobItem.jsx";

export default function ExampleJobsPage({data, theme}) {
  const deployExampleJobs = ()=>{
    return data.jobs.map((item, inx)=>{
      return <ExampleJobItem key={`exampleJobsItem_inx_${inx}`} item={item} theme={theme}/>
    })
  }
  return (
    <div className='exampleJobsPage' style={{backgroundColor:`${theme.secondary_color}`}}>
      <h3 className="exampleJobsPage_header" style={{textShadow:`2px 2px 4px ${theme.primary_color}`, color:`${theme.accent_color}`}}>דרושים עובדים לחברת Webingo</h3>
      <div className="exampleJobsPage_list">
        {deployExampleJobs()}
      </div>
    </div>
  )
}
